/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimesheetReportEntry } from './TimesheetReportEntry';
import {
    TimesheetReportEntryFromJSON,
    TimesheetReportEntryFromJSONTyped,
    TimesheetReportEntryToJSON,
} from './TimesheetReportEntry';

/**
 * 
 * @export
 * @interface TimesheetReport
 */
export interface TimesheetReport {
    /**
     * 
     * @type {Array<TimesheetReportEntry>}
     * @memberof TimesheetReport
     */
    entries: Array<TimesheetReportEntry>;
}

/**
 * Check if a given object implements the TimesheetReport interface.
 */
export function instanceOfTimesheetReport(value: object): value is TimesheetReport {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function TimesheetReportFromJSON(json: any): TimesheetReport {
    return TimesheetReportFromJSONTyped(json, false);
}

export function TimesheetReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimesheetReport {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(TimesheetReportEntryFromJSON)),
    };
}

export function TimesheetReportToJSON(value?: TimesheetReport | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entries': ((value['entries'] as Array<any>).map(TimesheetReportEntryToJSON)),
    };
}

